export default __webpack_public_path__ + "static/media/earn-asset.e2cfc22b.png";